<div *ngIf="config">
  <h3>{{config.name}}</h3>

  <div class="container-fluid">
    <ngx-monaco-editor
      class="monaco-editor"
      [options]="editorOptions"
      [(ngModel)]="editorValue"
      (ngModelChange)="getLineCount('edit')"
    >
    </ngx-monaco-editor>
  </div>
  <button type="button" class="btn btn-warning" (click)="cancel()">Cancel</button>
  <button type="button" class="btn btn-success" (click)="save(config, editorValue)">Save</button><br>
  <h6 *ngIf="this.originalLineCount" class="orignal">Original line Count: {{originalLineCount}}</h6>
  <h6 *ngIf="this.newLinesCount !== this.originalLineCount && this.newLinesCount" class="modified">Modified lines Count: {{newLinesCount}}</h6>
</div>

